import { Injectable } from '@angular/core';
import { SICOM_PATHS } from 'src/sicom-paths';
import { AbstractReportJobService } from '@/core/services/report-job/abstract-report-job.service';

/** Job service (polling/sessionStorage/download) da Declaração de Dados da Empresa PJ. */
@Injectable({ providedIn: 'root' })
export class DeclaracaoDadosEmpresaPjJobService extends AbstractReportJobService {
    protected readonly sessionKey = 'declaracao-dados-empresa-pj-jobId';
    protected readonly baseUrl = SICOM_PATHS.registro.prestador.reports.declaracaoDadosEmpresaPj;
}
